import { BaseBus } from './BaseBus';

export class VisitsCountBus extends BaseBus
{
    constructor(data: VisitsCountBus = null) {
        super(data);
    }
    CID(): any {
        return this.personId;
    }
personId: any;
visits: number;
tech: string;
cellNumber: string;
mainNumber: string;
contactEmail: string;
isAssigned: boolean;
    requireClockInOut: boolean;
    canSelect: boolean = true;
}
